const SITUATIONS = [
  {
    icon: 'ri-home-gear-line',
    title: 'Нет гаража на участке',
    desc: 'Навес — доступная альтернатива капитальному гаражу. Быстрый монтаж за 2–4 дня без&nbsp;стройки и&nbsp;бетонных&nbsp;работ.',
  },
  {
    icon: 'ri-car-line',
    title: 'Нужно укрыть две машины',
    desc: 'Изготовим широкий навес на два автомобиля (машин) — обе машины будут под&nbsp;защитой круглый&nbsp;год.',
  },
  {
    icon: 'ri-home-2-line',
    title: 'Навес у дома или у въезда',
    desc: 'Пристроим навес к стене дома или поставим отдельно у&nbsp;въезда. Компактно и&nbsp;удобно.',
  },
  {
    icon: 'ri-sun-line',
    title: 'Защита от солнца и наледи',
    desc: 'Поликарбонат задерживает UV-лучи, а крепкий каркас выдерживает снеговую нагрузку. Машина всегда чистая и&nbsp;сухая.',
  },
];

export default function UseCasesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Подойдёт, если вам нужно
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Четыре ситуации, в которых навес (машин) решает проблему с&nbsp;парковкой и&nbsp;защитой автомобиля
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {SITUATIONS.map((item, idx) => (
            <div
              key={item.title}
              className="group bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-6 transition-all duration-400 hover:border-primary-200/50 animate-fade-in-up"
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-400">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: item.desc }}></p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}